// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_l9-0";